import styled from 'styled-components'


export const ImageWrapper = styled.a`
  overflow: hidden;
  display: block;
  position: relative;
  &:hover,
  &:focus {
    text-decoration: none;
  }
  img,
  >div {
    width: 100%;
    height: auto;
    transform: scale(1);
    transition: transform 0.35s ease-in-out;
    &:focus,
    &:hover {
      transform: scale(1.1);
    }
  }
`